import { render, staticRenderFns } from "./EditChannelCode.vue?vue&type=template&id=bd9226f4&scoped=true"
import script from "./EditChannelCode.vue?vue&type=script&lang=js"
export * from "./EditChannelCode.vue?vue&type=script&lang=js"
import style0 from "./EditChannelCode.vue?vue&type=style&index=0&id=bd9226f4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9226f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd9226f4')) {
      api.createRecord('bd9226f4', component.options)
    } else {
      api.reload('bd9226f4', component.options)
    }
    module.hot.accept("./EditChannelCode.vue?vue&type=template&id=bd9226f4&scoped=true", function () {
      api.rerender('bd9226f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/channelCode/components/EditChannelCode.vue"
export default component.exports